import $ from 'jquery'
import vhCheck from "vh-check";

$(document).on('ready turbolinks:load', () => {
    vhCheck()
})